import React from 'react';
import {makeStyles} from "@material-ui/styles";

export const MODE_IDLE = undefined;
export const MODE_ASC = 'asc';
export const MODE_DESC = 'desc';


const useStyles = makeStyles(
    (theme) => {
        return {
            root: {
                '&:hover': {
                    backgroundColor: theme.palette.primary.light,
                    cursor: 'pointer'
                }
            },
        }
    }
);

export default function TableColumnHeader(props){

    const classes = useStyles();

    const {children,mode,column,onChangeMode, style} = props;

    function onColumnClicked(){

        let nextMode = MODE_IDLE;

        if(!mode)
            nextMode = MODE_ASC;

        if(mode == MODE_ASC)
            nextMode = MODE_DESC;

        if(mode == MODE_DESC)
            nextMode = MODE_IDLE;

        onChangeMode(column,nextMode);
    }

    return (
        <div onClick={onColumnClicked} className={`${classes.root} d-flex align-items-center`} style={style}>
            <div className={''}>
                {props.children}
            </div>
            <div className={'small'}>
                {
                    mode === MODE_ASC && (
                        <span className={'flaticon2-arrow-up'}></span>
                    )
                }
                {
                    mode === MODE_DESC && (
                        <span className={'flaticon2-arrow-down'}></span>
                    )
                }
                {
                    (!mode) && (
                        <>
                            <span className={'flaticon2-arrow-up'}></span>
                            <span className={'flaticon2-arrow-down'}></span>
                        </>
                    )
                }
            </div>
        </div>
    );

}